import inViewport from '@resources/js/helpers/inViewport'
import initGalleries from '@resources/js/components/galleries'
import Toggle from '@resources/js/ui/Toggle'

initGalleries()

const amenitiesElements = document.querySelectorAll('.js-amenities')

amenitiesElements.forEach(element => {
    inViewport(element, () => {
        new Toggle(element.querySelector('.js-toggle-amenities-wrap'), {
            target: element.querySelector('.js-amenities-wrap')
        })

        new Toggle(element.querySelector('.js-amenities-list-toggle'), {
            target: element.querySelector('.js-amenities-list')
        })
    })
})
